export default "### ENS - Ethereum Naming Service\n";